import { render, staticRenderFns } from "./HistoryRemindTask.vue?vue&type=template&id=a1e92ef8&scoped=true&"
import script from "./HistoryRemindTask.vue?vue&type=script&lang=js&"
export * from "./HistoryRemindTask.vue?vue&type=script&lang=js&"
import style0 from "./HistoryRemindTask.vue?vue&type=style&index=0&id=a1e92ef8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e92ef8",
  null
  
)

export default component.exports